export default "__VITE_ASSET__vuEFhnWQ__"